import { Error } from "../../interface/upplm.common.interface";
import { Address, AutoApproveCriteria, AutoApproveResults, Contact, PlacardDetails, PlacardImage, SelectedDays } from "../../interface/upplm.placardInformation";
import { ApproveRejectNotification } from "./approveRejectNotification";

export class PlacardEditionRequest {
    address: Address = null;
    companyName: string = null;
    contactDetails: Contact[] = null;
    placardDetails: PlacardDetailsRequest = null;
    pickupPlanType: string = null;
    selectedDays: SelectedDays[] = null;
    placardImage: PlacardImage = null;
    pickupStartDate: string = null;
    customerFacingStartDate: string = null;
    metalBoxInd?: boolean = null;
    lockCombination: string = null;
    pickupLocation: string = null;
    placardLocation: string = null;
    additionalLocationDetails: string = null;
    internalUserName: string = null;
    userName: string = null;
    internalUserEmail: string = null;
    changeJustification: string
    notifications: ApproveRejectNotification[];
    transactionSource: string;
}

export class PlacardEditionResponse {
    placardId: string;
    updatedResult: boolean;
    address: Address = new Address();
    companyName: string;
    contactDetails: Contact[];
    placardDetails: PlacardDetails;
    pickupPlanType: string;
    selectedDays: SelectedDays[];
    placardImage: PlacardImage;
    pickupStartDate: string;
    metalBoxInd: boolean;
    lockCombination: string;
    pickupLocation: string;
    placardLocation: string;
    additionalLocationDetails: string;
    internalUserName: string;
    errors?: Error[];
    updatedRequestSaved: boolean;
    autoApproveCriteria: AutoApproveCriteria;
    autoApproveResults: AutoApproveResults;
}

export class PlacardDetailsRequest {
    locationType: string;
    placardTypeKey: string;
    placardSizeKey: string;
}
